import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Tooltip, IconButton, Chip } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import SyncIcon from '@material-ui/icons/Sync';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import StoreContext from '../Store/context';
import { usePOS } from '../../contexts/POSContext';
import UILogo from '../UI/Logo/UILogo';

const POSHeader = () => {
  const history = useHistory();
  const { credencials, setModalCashierSelect } = useContext(StoreContext);
  const { isSyncing, syncCatalog, products, services, isDarkMode, toggleTheme, activeCashier } = usePOS();
  const totalAvailableItems = (products?.length || 0) + (services?.length || 0);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(() => { });
    } else {
      document.exitFullscreen().catch(() => { });
    }
  };

  const handleExitPOS = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => { });
    }
    history.push('/home');
  };

  const navShortcuts = [
    { label: 'Modo PDV', route: '/pdv' },
    { label: 'Nova venda', route: '/home/vendas/nova' },
    { label: 'Comandas', route: '/home/vendas/comanda' },
    { label: 'Novo Cliente', route: '/home/clientes/novo' },
    { label: 'Abrir/ Fechar Caixa', route: '/home/caixas/detalhes' },
  ];

  const linkToPage = (route) => {
    if (history.location.pathname !== route) {
      if (document.fullscreenElement) {
        document.exitFullscreen().catch(() => {});
      }
      history.push(route);
    }
  };

  return (
    <header className="pos-header">
      <div className="pos-header-left">
        <Tooltip title="Voltar para a página inicial">
          <IconButton
            size="small"
            onClick={handleExitPOS}
            style={{ color: isDarkMode ? '#90caf9' : '#17497F', marginRight: 4 }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>

        <UILogo name="Duzz" lastName="Commercial" size={16} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 16 }}>
          <span style={{ fontSize: '0.9rem', fontWeight: 700, color: isDarkMode ? '#90caf9' : '#17497F' }}>
            Frente de Caixa (PDV)
          </span>

          <Tooltip title="Clique para sincronizar o catálogo de produtos e serviços">
            <Chip
              icon={
                <SyncIcon
                  style={{
                    fontSize: 16,
                    color: isDarkMode ? '#81c784' : '#185421',
                    animation: isSyncing ? 'spin 1s linear infinite' : 'none',
                  }}
                />
              }
              label={`${totalAvailableItems} ${totalAvailableItems === 1 ? 'item disponível' : 'itens disponíveis'}`}
              size="small"
              clickable
              onClick={() => syncCatalog(true)}
              style={{
                backgroundColor: isDarkMode ? 'rgba(46, 125, 50, 0.2)' : '#e8f5e9',
                color: isDarkMode ? '#81c784' : '#185421',
                border: isDarkMode ? '1px solid rgba(129, 199, 132, 0.4)' : '1px solid #c8e6c9',
                fontWeight: 600,
                fontSize: '0.75rem',
              }}
            />
          </Tooltip>
        </div>
      </div>

      {/* Botões de Navegação do Sistema */}
      <div className="pos-header-nav">
        {navShortcuts.map((item) => {
          const isActive = history.location.pathname === item.route;
          return (
            <Button
              key={item.route}
              className={`pos-nav-button ${isActive ? 'active' : ''}`}
              variant="contained"
              size="small"
              onClick={() => linkToPage(item.route)}
            >
              {item.label}
            </Button>
          );
        })}
      </div>

      <div className="pos-header-right">
        {/* Botão de Caixa da Sessão */}
        <Button
          variant="outlined"
          size="small"
          onClick={() => setModalCashierSelect(true)}
          style={{
            borderColor: isDarkMode ? '#38bdf8' : '#17497F',
            color: isDarkMode ? '#38bdf8' : '#17497F',
            textTransform: 'none',
            fontSize: '0.78rem',
            fontWeight: 700,
            padding: '2px 10px',
          }}
        >
          {credencials?.cashSession && activeCashier
            ? activeCashier.name
            : 'Selecionar Caixa'}
        </Button>

        {credencials && (
          <span style={{ fontSize: '0.82rem', color: isDarkMode ? '#94a3b8' : '#616161' }}>
            Operador: <strong style={{ color: isDarkMode ? '#f8fafc' : '#212121' }}>{credencials.name || 'Jonas'}</strong>
          </span>
        )}

        {/* Botão Alternar Modo Escuro / Claro */}
        <Tooltip title={isDarkMode ? 'Mudar para Modo Claro' : 'Mudar para Modo Escuro'}>
          <IconButton
            size="small"
            onClick={toggleTheme}
            style={{ color: isDarkMode ? '#facc15' : '#17497F' }}
          >
            {isDarkMode ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Tooltip>

        <Tooltip title="Tela Cheia (F11)">
          <IconButton
            size="small"
            onClick={toggleFullscreen}
            style={{ color: isDarkMode ? '#90caf9' : '#17497F' }}
          >
            <FullscreenIcon />
          </IconButton>
        </Tooltip>

        <Button
          variant="outlined"
          size="small"
          onClick={handleExitPOS}
          style={{
            borderColor: isDarkMode ? '#334155' : '#e0e0e0',
            color: isDarkMode ? '#cbd5e1' : '#616161',
            textTransform: 'none',
            fontSize: '0.78rem',
            fontWeight: 600,
          }}
        >
          Sair [Esc]
        </Button>
      </div>
    </header>
  );
};

export default POSHeader;
